
import {createSlice} from '@reduxjs/toolkit'
import { fetchsupplementalpay } from '../../action/master/supplementalpayAction'

interface supplementalpayState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: supplementalpayState = {
  data: null,
  status: 'idle',
  error: null,
}

const supplementalpaySlice = createSlice({
  name: 'supplementalpay',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchsupplementalpay.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchsupplementalpay.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchsupplementalpay.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default supplementalpaySlice.reducer
